import React, { createContext, useEffect, useState, useContext } from 'react';
import {
  SingleEventHandler,
  withProviderErrorBoundary,
} from '@edreamsodigeo/frontend-core';
import { TriggerProvider, CabinBagsProvider } from 'providers';
import withCabinBagsContext from '../../../withCabinBagsContext';

const EventRequestHandler = () => {
  const singleEventHandler = SingleEventHandler();
  return {
    execute: singleEventHandler.trigger,
    onExecute: singleEventHandler.listen,
    stopOnExecute: singleEventHandler.stopListening,
  };
};

export const eventRequestHandler = EventRequestHandler();
const EventContext = createContext();
export const useEventContext = () => useContext(EventContext);

const OF1ContinuanceNagBaseProvider = ({
  initialValue = {},
  triggerHandler = () => {},
  children,
}) => {
  const [executeEvent, setExecuteEvent] = useState(initialValue);

  useEffect(() => {
    eventRequestHandler.onExecute((event) => {
      setExecuteEvent({
        event,
        timestamp: Date.now(),
      });
    });

    return () => {
      eventRequestHandler.stopOnExecute();
    };
  }, []);

  return (
    <EventContext.Provider value={executeEvent}>
      <TriggerProvider triggerHandler={triggerHandler}>
        <CabinBagsProvider>{children}</CabinBagsProvider>
      </TriggerProvider>
    </EventContext.Provider>
  );
};

const OF1ContinuanceNagBaseProviderWithErrorBoundary =
  withProviderErrorBoundary(OF1ContinuanceNagBaseProvider, {
    name: 'cabin-bags OF1ContinuanceNagProvider',
  });

export const OF1ContinuanceNagProvider = withCabinBagsContext(
  OF1ContinuanceNagBaseProviderWithErrorBoundary
);
